export enum FilteringType {
	Contains = 1,
	Equals = 2,
	StartWith = 3,
	EndWith = 4,
	GreaterThan = 5,
	LessThan = 6,
	IsEmpty = 7,
	IsNotEmpty = 8,
	NotContains = 9
}
